
/**
 * 避让逻辑
 * **/
import  EventEmitter  from "If_AdTool/common/EventEmitter";
//code处理
const floatAdCode = ["cbpTpl", "cbkTpl","cfpTpl",""]
function checkFloatAdCode(code){
    let nCode = code;
    //如果模版已经编码，则解码，没有编码则不需要解码
    let start = -1, startStr = "", endStr = "";
    let end = -1;
    let pre = "#";
    if (nCode.indexOf("<!--!") != -1) {
        pre = "!";
    }
    startStr = "<!--" + pre;
    endStr = pre + "-->";
    start = nCode.indexOf(startStr) + startStr.length;
    end = nCode.indexOf(endStr);
    if (start != -1 && end != -1 && end >= start) {
        nCode = nCode.substring(start, end);
    };
    let adCode = decodeURIComponent(nCode);
    let isJson =false;
    try{
        adCode = JSON.parse(adCode);
        isJson = true;
    }catch(e){
    }
    if (isJson){
        //console.log(adCode);
        //debugger;
        return adCode.callback!="yg";
    }
    return false
}
function birangfun(ele,adData)  {
   let list = [];
    function next(){
        if(list.length>0){
            let fn =list.shift();
            fn();
        }
    }
    for(let i=0;i<adData.aids.length;i++){
        let item = adData.aids[i];
        list.push((function(ele,item){
            return function(){
                console.log("开始播放",item.ap)
                let f_event = new EventEmitter,T;  
                let el =ele;
                if (item.hasOwnProperty("el")){
                    if (item.el =="newDiv"){
                        el = document.createElement("div");
                    }
                    delete item.el;
                }
                f_event.once("playEnd",function(){
                    clearTimeout(T);
                    setTimeout(next, 500);
                })
                if (item.adControl){
                    let control = item.adControl;
                    delete item.adControl;
                    IfengAmgr.adControl({ showIntervalTime: control.showIntervalTime, handler: function () { showAd(el, item, f_event) }, apid: item.ap, delayTime: control.delayTime})
                }else{
                    showAd(el, item, f_event);
                }
                T = setTimeout(() => { console.log("单个广告播放超时",item.ap);f_event.emit("playEnd");},20000)
            }
        })(ele,item))
    }
    next();

}
function showAd(el, item, f_event){
    IfengAmgr.show(el, { aids: [{ ...item, "extCode": { "event": f_event } }] }, {
        RenderError: function (data, res) {
            console.log("广告出错或则无广告", data, item.ap, res)
            f_event.emit("playEnd");
        }, DataCmp: function (res) {
            //需要判断是否是浮动广告
            if (res&&res[item.ap] && res[item.ap].code && !checkFloatAdCode(res[item.ap].code)) {
                console.log("不是浮动广告", res, item.ap)
                f_event.emit("playEnd");
            }
        }
    });
}
if (typeof  window.IfengAmgr != undefined) {
    window.IfengAmgr.tplLib.birang = {render: birangfun};
}